export enum ViewEnum {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    CLEAR = 'clear',
    OUTLINED = 'outlined'
}

export type View = 'primary' | 'secondary' | 'clear' | 'outlined';
